import { LoadingStatusType, PeakPayrollExceptionCode } from "@/enums/enums";
import { AccessToken, RefreshToken } from "@/helper/userHelper";
import API from "@/service/Index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
@Module({ namespaced: true })
export default class Statement extends VuexModule {
  public statementActive: any = null;
  public statementActiveLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public statementActiveStatus: any = null;
  public createStatementLoadingStatus: LoadingStatusType = LoadingStatusType.None;
  public statementIsLogin: boolean | null = null;
  public statementLoginLoadingStatus = LoadingStatusType.None;
  public updateStatementLoadingStatus = LoadingStatusType.None;
  get getStatementActive(): any {
    return this.statementActive;
  }
  get getStatementActiveLoadingStatus(): LoadingStatusType {
    return this.statementActiveLoadingStatus;
  }
  get getStatementActiveStatus(): any {
    return this.statementActiveStatus;
  }
  get getCreateStatementLoadingStatus(): LoadingStatusType {
    return this.createStatementLoadingStatus;
  }
  get getStatementIsLogin(): boolean | null {
    return this.statementIsLogin;
  }
  get getStatementLoginLoadingStatus(): LoadingStatusType {
    return this.statementLoginLoadingStatus;
  }
  get getUpdateStatementLoadingStatus(): LoadingStatusType {
    return this.updateStatementLoadingStatus;
  }
  @Mutation
  public MutationStatementActive(statementActive: any) {
    this.statementActive = statementActive;
  }
  @Mutation
  public MutationStatementActiveLoadingStatus(status: LoadingStatusType) {
    this.statementActiveLoadingStatus = status;
  }
  @Mutation
  public MutationStatementActiveStatus(status: any) {
    this.statementActiveStatus = status;
  }
  @Mutation
  public MutationCreateStatementLoadingStatus(status: LoadingStatusType) {
    this.createStatementLoadingStatus = status;
  }
  @Mutation MutationSetStatementIsLogin(isLogin: boolean) {
    this.statementIsLogin = isLogin;
  }
  @Mutation MutationSetstatementLoginLoadingStatus(status: LoadingStatusType) {
    this.statementLoginLoadingStatus = status;
  }
  @Mutation MutationUpdateStatementLoadingStatus(status: LoadingStatusType) {
    this.updateStatementLoadingStatus = status;
  }
  @Action
  public DoGetStatementActiveDetail(input: any) {
    if (this.statementActiveLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationStatementActiveLoadingStatus", LoadingStatusType.Loading);
      API.StatementService.DoGetStatementActiveDetail(input.salaryId, input.employeeId, input.merchantId)
        .then((resStatementActiveDetail) => {
          if (resStatementActiveDetail.data.responseCode.IsSuccess()) {
            this.context.commit("MutationStatementActive", resStatementActiveDetail.data.statementActive);
          } else {
            this.context.commit("MutationSetStatementIsLogin", false);
          }
          this.context.commit("MutationStatementActiveLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        })
        .catch((error) => error);
    }
  }
  @Action
  public DoGetStatementActiveDetailByPasscode(input: any) {
    if (this.statementActiveLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationStatementActiveLoadingStatus", LoadingStatusType.Loading);
      API.StatementService.DoGetStatementActiveDetailByPasscode(
        input.salaryId,
        input.employeeId,
        input.merchantId,
        input.passcode
      )
        .then((resStatementActiveDetail) => {
          this.context.dispatch("Loading/IsLoading", false, { root: true });
          if (resStatementActiveDetail.data.responseCode.IsSuccess()) {
            this.context.commit("MutationStatementActive", resStatementActiveDetail.data.statementActive);
          } else {
            if (resStatementActiveDetail.data.exception.code == PeakPayrollExceptionCode.StatementSlipPasscodeNull) {
              this.context.commit("MutationStatementActiveStatus", "Text_Alert_Passcode_Null");
            } else if (resStatementActiveDetail.data.exception.code == PeakPayrollExceptionCode.PasscodeInvalid) {
              this.context.commit("MutationStatementActiveStatus", "Wrong_OTP_Code");
            } else {
              this.context.commit("MutationStatementActiveStatus", "Text_SlipVoided");
            }
          }
          this.context.commit("MutationStatementActiveLoadingStatus", LoadingStatusType.Success);
        })
        .catch((error) => error);
    }
  }
  @Action
  public DoCreateStatement(salaryId: number) {
    if (this.createStatementLoadingStatus !== LoadingStatusType.Loading) {
      this.context.commit("MutationCreateStatementLoadingStatus", LoadingStatusType.Loading);
      API.StatementService.DoCreateStatement(salaryId)
        .then((res) => {
          this.context.commit("MutationCreateStatementLoadingStatus", LoadingStatusType.Success);
          this.context.commit("MutationSalaryDetailLoadingStatus", LoadingStatusType.None);
          this.context.commit("MutationEmployeeHistoryDetailLoadingStatus", LoadingStatusType.None);
        })
        .catch((error) => error);
    }
  }
  @Action
  public DoCheckStatementIsLogin() {
    const accessToken = AccessToken();
    const refreshToken = RefreshToken();
    if (accessToken && refreshToken) {
      this.context.commit("MutationSetstatementLoginLoadingStatus", LoadingStatusType.Loading);
      try {
        API.AuthenService.DoGetUserInfo().then((resUserInfo) => {
          if (resUserInfo.status.IsSuccess()) {
            this.context.commit("MutationSetStatementIsLogin", true);
          } else {
            this.context.commit("MutationSetStatementIsLogin", false);
          }
          this.context.commit("MutationSetstatementLoginLoadingStatus", LoadingStatusType.Success);
        });
      } catch (err) {
        this.context.commit("MutationSetStatementIsLogin", false);
        this.context.commit("MutationSetstatementLoginLoadingStatus", LoadingStatusType.Success);
      }
    } else {
      this.context.commit("MutationSetStatementIsLogin", false);
      setTimeout(() => {
        this.context.commit("MutationSetstatementLoginLoadingStatus", LoadingStatusType.Success);
      }, 50);
    }
  }
  @Action
  public DoUpdateStatement(input: any) {
    if (this.statementActiveLoadingStatus !== LoadingStatusType.Loading) {
      this.context.dispatch("Loading/IsLoading", true, { root: true });
      this.context.commit("MutationUpdateStatementLoadingStatus", LoadingStatusType.Loading);
      API.StatementService.DoUpdateStatement(input)
        .then((res) => {
          this.context.commit("MutationUpdateStatementLoadingStatus", LoadingStatusType.Success);
          this.context.dispatch("Loading/IsLoading", false, { root: true });
        })
        .catch((error) => error);
    }
  }
  @Action
  public DoUpdateStatementAsync(input: any) {
    return new Promise((resolve, reject) => {
      API.StatementService.DoUpdateStatement(input).then((res) => {
        resolve(res);
      });
    });
  }
}
